(function () {
  function placeAddonsSection() {
    var panel = document.getElementById('cdp-addons-panel');
    if (!panel || panel.classList.contains('cdp-addons-section')) return;
    var productView = panel.closest('.productView');
    var calendar = panel.closest('.products_details_calender');
    panel.classList.add('cdp-addons-section');
    panel.querySelector('.cdp-addons-title').textContent = 'Add-ons';
    if (productView) productView.insertAdjacentElement('afterend', panel);
    else if (calendar) calendar.insertAdjacentElement('afterend', panel);
    var anchor = panel;
    var reserve = document.getElementById('book-me-container');
    var highlights = document.getElementById('highlights-section');
    if (reserve) {
      reserve.classList.add('cdp-reserve-after-addons');
      anchor.insertAdjacentElement('afterend', reserve);
      anchor = reserve;
    }
    if (highlights) {
      highlights.classList.add('cdp-highlights-after-addons');
      anchor.insertAdjacentElement('afterend', highlights);
    }
  }

  var descriptionTooltip;
  function showDescriptionTooltip(element) {
    if (descriptionTooltip) descriptionTooltip.remove();
    descriptionTooltip = document.createElement('div');
    descriptionTooltip.className = 'cdp-addon-description-tooltip';
    descriptionTooltip.textContent = element.textContent.trim();
    document.body.appendChild(descriptionTooltip);
    var rect = element.getBoundingClientRect();
    var tipRect = descriptionTooltip.getBoundingClientRect();
    var left = Math.max(12, Math.min(rect.left, window.innerWidth - tipRect.width - 12));
    var top = rect.top - tipRect.height - 9;
    if (top < 12) top = rect.bottom + 9;
    descriptionTooltip.style.left = left + 'px';
    descriptionTooltip.style.top = top + 'px';
  }

  function hideDescriptionTooltip() {
    if (descriptionTooltip) descriptionTooltip.remove();
    descriptionTooltip = null;
  }

  function selectedVariant() {
    if (typeof window.resolveSelectedVariant === 'function') return window.resolveSelectedVariant();
    var details = window.productDetails;
    if (!details || !Array.isArray(details.variants)) return null;
    var id = new URLSearchParams(location.search).get('variant');
    return details.variants.find(function (v) { return v.id == id || v.variantId == id; }) || details.variants[0];
  }

  function openGallery(addon) {
    var images = Array.isArray(addon.images) ? addon.images.filter(Boolean) : [];
    if (!images.length) return;

    var index = 0;
    var previousOverflow = document.body.style.overflow;
    var modal = document.createElement('div');
    modal.className = 'cdp-addon-gallery';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', (addon.title || 'Add-on') + ' photos');
    modal.innerHTML =
      '<div class="cdp-addon-gallery__dialog">' +
        '<div class="cdp-addon-gallery__header">' +
          '<div><strong class="cdp-addon-gallery__title"></strong><span class="cdp-addon-gallery__counter"></span></div>' +
          '<button type="button" class="cdp-addon-gallery__close" aria-label="Close gallery">&times;</button>' +
        '</div>' +
        '<div class="cdp-addon-gallery__stage">' +
          '<button type="button" class="cdp-addon-gallery__arrow cdp-addon-gallery__prev" aria-label="Previous photo">&#8249;</button>' +
          '<img class="cdp-addon-gallery__image" alt="">' +
          '<button type="button" class="cdp-addon-gallery__arrow cdp-addon-gallery__next" aria-label="Next photo">&#8250;</button>' +
        '</div>' +
        '<div class="cdp-addon-gallery__thumbs"></div>' +
      '</div>';

    var mainImage = modal.querySelector('.cdp-addon-gallery__image');
    var counter = modal.querySelector('.cdp-addon-gallery__counter');
    var thumbs = modal.querySelector('.cdp-addon-gallery__thumbs');
    var prev = modal.querySelector('.cdp-addon-gallery__prev');
    var next = modal.querySelector('.cdp-addon-gallery__next');
    modal.querySelector('.cdp-addon-gallery__title').textContent = addon.title || 'Add-on photos';

    images.forEach(function (src, i) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cdp-addon-gallery__thumb';
      button.setAttribute('aria-label', 'View photo ' + (i + 1));
      var image = document.createElement('img');
      image.src = src;
      image.alt = '';
      image.loading = 'lazy';
      button.appendChild(image);
      button.onclick = function () { index = i; render(); };
      thumbs.appendChild(button);
    });

    function render() {
      mainImage.src = images[index];
      mainImage.alt = (addon.title || 'Add-on') + ' photo ' + (index + 1);
      counter.textContent = (index + 1) + ' / ' + images.length;
      thumbs.querySelectorAll('.cdp-addon-gallery__thumb').forEach(function (button, i) {
        button.classList.toggle('is-active', i === index);
        button.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var active = thumbs.children[index];
      if (active) active.scrollIntoView({ block: 'nearest', inline: 'center' });
    }

    function move(delta) {
      index = (index + delta + images.length) % images.length;
      render();
    }

    function close() {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
      modal.remove();
    }

    function onKey(event) {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    }

    prev.onclick = function () { move(-1); };
    next.onclick = function () { move(1); };
    modal.querySelector('.cdp-addon-gallery__close').onclick = close;
    modal.onclick = function (event) { if (event.target === modal) close(); };
    if (images.length === 1) {
      prev.hidden = true;
      next.hidden = true;
      thumbs.hidden = true;
    }

    var touchStart = 0;
    mainImage.addEventListener('touchstart', function (event) { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    mainImage.addEventListener('touchend', function (event) {
      var distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) > 45) move(distance > 0 ? -1 : 1);
    }, { passive: true });

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    render();
    modal.querySelector('.cdp-addon-gallery__close').focus();
  }

  placeAddonsSection();
  document.addEventListener('mouseover', function (event) {
    var description = event.target.closest && event.target.closest('#cdp-addons-list .cdp-addon-desc');
    if (description) showDescriptionTooltip(description);
  });
  document.addEventListener('mouseout', function (event) {
    var description = event.target.closest && event.target.closest('#cdp-addons-list .cdp-addon-desc');
    if (description && !description.contains(event.relatedTarget)) hideDescriptionTooltip();
  });
  document.addEventListener('click', function (event) {
    var media = event.target.closest && event.target.closest('#cdp-addons-list .cdp-addon-media');
    if (media) {
      var card = media.closest('.cdp-addon-card');
      var variant = selectedVariant();
      var addon = variant && Array.isArray(variant.addOns)
        ? variant.addOns.find(function (item) { return String(item._id) === card.getAttribute('data-addon-id'); })
        : null;
      if (addon && Array.isArray(addon.images) && addon.images.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openGallery(addon);
        return;
      }
    }
    var addOnCard = event.target.closest && event.target.closest('#cdp-addons-list .cdp-addon-card');
    if (addOnCard && typeof window.getAddOnBillingDays === 'function' && window.getAddOnBillingDays() < 1) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof window.showNotification === 'function') {
        var checkoutNeeded = typeof window.usesCheckInCheckOutDates === 'function' && window.usesCheckInCheckOutDates();
        window.showNotification(checkoutNeeded ? 'Please select your check-out date before choosing add-ons.' : 'Please select your booking date before choosing add-ons.', 'error');
      }
    }
  }, true);
})();
